import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface IProps {
  width?: number;
  height?: number;
  color?: string;
}

const NewHomeIconOutline: React.FC<IProps> = ({
  width = 33,
  height = 32,
  color: stroke = '#282828',
}) => (
  <Svg width={width} height={height} viewBox="0 0 33 32" fill="none">
    <Path
      d="M12.5 29.3337V16.0003H20.5V29.3337M4.5 12.0003L16.5 2.66699L28.5 12.0003V26.667C28.5 27.3742 28.219 28.0525 27.719 28.5526C27.2189 29.0527 26.5406 29.3337 25.8333 29.3337H7.16667C6.45942 29.3337 5.78115 29.0527 5.28105 28.5526C4.78095 28.0525 4.5 27.3742 4.5 26.667V12.0003Z"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default NewHomeIconOutline;